export { DaysHeadersStrip } from './ui/DaysHeadersStrip';
